import supabase from "../../../shared/database/supabase";
import { ServiceOrderLineRepository } from "../../../models/service-order-line/service-order-line.repository";
import { ServiceOrderLine } from "../model/service-order-line";

export const createServiceOrderLine = async (serviceOrderLine: ServiceOrderLine) => {
    try {
        const { data, error } = await supabase.functions.invoke<ServiceOrderLineRepository>("create-service-order-line", {
            body: JSON.stringify({
                service_order_line_type: serviceOrderLine.serviceOrderLineType.id,
                service_order_id: serviceOrderLine.serviceOrderId,
                nuovauto_claim_id: serviceOrderLine.nuovautoClaimId,
                audatex_claim_id: serviceOrderLine.audatexClaimId,
                car_rental_id: serviceOrderLine.carRentalId,
                car_id: serviceOrderLine.car?.id,
                cost: serviceOrderLine.cost,
                discount: serviceOrderLine.discount,
                work_hours: serviceOrderLine.workHours,
                cost_by_work_hour: serviceOrderLine.costByWorkHour,
                created_by: serviceOrderLine.createdBy,
                finished: serviceOrderLine.finished,
            }),
        });

        if (error) {
            console.error("Error calling create-service-order-line:", error);
            return { data: null, error };
        }
        return { data: data, error: null };
    } catch (err) {
        console.error("Exception in createServiceOrderLine:", err);
        throw err;
    }
};